export default __webpack_public_path__ + "static/canyons-2e6d28c86b9c07253d0a44152a9a7aa5.jpg";